/**
 * StatisticsFilter
 * --
 */
import React, { useState } from 'react';
import { ExpandableContainer, Content, Row, Col } from 'components';
import { DatePicker, Radio, Button } from 'antd';
import moment from 'moment';
import MessageAlert from 'utils';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
const initialSearchFilter = {
  dateType: 'month', // [today, week, month, 3month]
  startDate: null,
  endDate: null,
  // startDate: moment().add(-30, 'days').format('YYYY-MM-DD'),
  // endDate: moment().format('YYYY-MM-DD'),
};

/**----------------------------------------
 * [Component] 필터
 * ----------------------------------------
 */
const StatisticsFilter = ({ onSearch, onReset }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [searchFilter, setSearchFilter] = useState(initialSearchFilter);

  /* ===== FUNCTION ===== */
  /**--------------------
   * 데이터 바인딩
   * --------------------
   */
  const handleChange = (key, value) => {
    setSearchFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /**--------------------
   * 필터 초기화
   * --------------------
   */
  const handleSearch = (reset = false) => {
    const { dateType, startDate, endDate } = searchFilter;

    // 예외처리1: 빈값 체크
    if ((!startDate && endDate) || (startDate && !endDate)) {
      MessageAlert.warning('날짜를 모두 입력해주세요');
      return;
    }

    // 예외처리2: 시작일보다 종료일이 작은경우
    if (moment(endDate).isBefore(startDate)) {
      MessageAlert.warning('종료일 시작일보다 작게 설정해주세요.');
      return;
    }

    let start;
    let end = moment().format('YYYY-MM-DD');

    // 7일
    if (dateType === 'week') {
      start = moment().add(-7, 'days').format('YYYY-MM-DD');
    }
    // 30일
    else if (dateType === 'month') {
      start = moment().add(-30, 'days').format('YYYY-MM-DD');
    }
    // 90일
    else if (dateType === '3month') {
      start = moment().add(-90, 'days').format('YYYY-MM-DD');
    }
    // 1일
    else {
      start = end;
    }

    onReset(
      reset
        ? {
            startDate: moment().add(-30, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          }
        : {
            startDate: startDate && endDate ? startDate : start,
            endDate: startDate && endDate ? endDate : end,
          }
    );
  };

  /**--------------------
   * 필터 초기화
   * --------------------
   */
  const handleResetFilter = () => {
    setSearchFilter(initialSearchFilter);
    handleSearch(true);
  };

  /* ===== VARIABLE ===== */
  const formItem = [
    {
      label: '기간설정',
      form: [
        {
          input: (
            <>
              <Radio.Group
                // size="large"
                // defaultValue="today"
                buttonStyle="solid"
                value={searchFilter.dateType}
                onChange={(e) => handleChange('dateType', e.target.value)}
                style={{ marginRight: 12 }}
                disabled={
                  searchFilter.startDate || searchFilter.endDate ? true : false
                }
              >
                <Radio.Button value="today">오늘</Radio.Button>
                <Radio.Button value="week">1주일(7일)</Radio.Button>
                <Radio.Button value="month">1개월(30일)</Radio.Button>
                <Radio.Button value="3month">3개월(90일)</Radio.Button>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '직접설정',
      form: [
        {
          input: (
            <>
              <DatePicker
                // size="large"
                format={'YYYY-MM-DD'}
                placeholder="시작일"
                style={{ ...styles.form.date }}
                value={searchFilter.startDate && dayjs(searchFilter.startDate)}
                maxDate={searchFilter.endDate && dayjs(searchFilter.endDate)}
                onChange={(d, t) => handleChange('startDate', t)}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                // size="large"
                format={'YYYY-MM-DD'}
                placeholder="종료일"
                style={{ ...styles.form.date }}
                value={searchFilter.endDate && dayjs(searchFilter.endDate)}
                minDate={
                  searchFilter.startDate && dayjs(searchFilter.startDate)
                }
                onChange={(d, t) => handleChange('endDate', t)}
              />
            </>
          ),
        },
      ],
    },
  ];

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content
        maxWidth={'100%'}
        padding={0}
        backgroundColor={'#fff'}
        className="boxShadow"
        style={{ borderRadius: 7 }}
      >
        <Row>
          <Col x={19}>
            <ExpandableContainer borderRadius={4} padding={'10px 14px'}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div
                    style={{
                      margin: '0 30px 0 10px',
                      fontSize: 14.5,
                      width: 60,
                      fontWeight: '500',
                      color: '#515151',
                    }}
                  >
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>
          </Col>

          {/* === === */}
          <Col
            x={5}
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <Button size="large" type="primary" onClick={() => handleSearch()}>
              <SearchOutlined /> 검색
            </Button>
            &nbsp;
            <Button size="large" onClick={handleResetFilter}>
              <ReloadOutlined /> 초기화
            </Button>
          </Col>
        </Row>
      </Content>
    </>
  );
};

const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  button: {
    width: 80,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    margin: '0px 4px',
  },
  form: {
    input: {
      large: {
        width: 135,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 145,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },
};

StatisticsFilter.defaultProps = {
  onSearch: () => {},
  onReset: () => {},
};
export default StatisticsFilter;
